import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import "assets/css/components/Tooltip.scss";
import { ReactComponent as IconHelp } from 'assets/images/icons/icon-help.svg';

type TooltipProps = {
  item: string,
  title: string,
  content: string
}

const Tooltip = ({ item, title, content }: TooltipProps): JSX.Element => {
  const { t } = useTranslation();
  const tooltipId = React.useId();
  const [isVisible, setIsVisible] = useState(false);
  const toggleTooltip = () => {
    setIsVisible(prevState => !prevState);
  };

  return (
    <div className='tooltip-block'>
      <button type='button' onClick={ toggleTooltip } aria-controls={ tooltipId } aria-expanded={ isVisible } className='tooltip-button'>
        <IconHelp />
        <span>
          { t('tooltip_toggle_label') }
          <span className='visually-hidden'>
            - { item }
          </span>
        </span>
      </button>
      { isVisible && (
        <div id={ tooltipId } className='tooltip-content'>
          <h2>{ title }</h2>
          <div dangerouslySetInnerHTML={ { __html: content } } />
        </div>
      ) }
    </div>
  );
};

export default Tooltip;
